import angular from "angular";
import panel from "../services";

function swipeCard(panel) {
  return {
    restrict: 'C',
    link: (scope, element, attrs) => {
      // we need a native DOM element for HammerJS, hence the [0] notation to retrieve it from the jQLite wrapper
      element = element[0];

      let textNo = element.querySelector('.card-image-no');
      let textYes = element.querySelector('.card-image-yes');

      // set the stack order and the cascade effect
      element.style.zIndex = 99 - attrs.index;
      let offsetTop = Math.min(Math.max((attrs.index * 5), 0), 15);

      // the active variable is used to render each frame of the animation
      let active = false;
      let transform;

      let reqAnimationFrame = (function () {
        return window[Hammer.prefixed(window, 'requestAnimationFrame')] || function (callback) {
          window.setTimeout(callback, 1000 / 60);
        };
      })();

      let mc = new Hammer.Manager(element);
      mc.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));

      $(element).on('swipe.left', (ev) => {
        textNo.style.opacity = 1;
        ev.isFinal = true;
        $(element).animate({left: "-=400"}, 100).css({transform: 'rotate(-15deg)'});
        offScreenLeft(ev);
      });

      $(element).on('swipe.right', (ev) => {
        textYes.style.opacity = 1;
        ev.isFinal = true;
        $(element).animate({left: "+=400"}, 100).css({transform: 'rotate(15deg)'});
        offScreenRight(ev);
      });

      // all animation takes place between when active changes state from true
      // in requestElementUpdate to false in updateElementTransform
      function requestElementUpdate() {
        if (!active) {
          reqAnimationFrame(updateElementTransform);
          active = true;
        }
      }

      function resetElement() {
        element.className = 'card tinder-card animate';
        textYes.style.opacity = 0;
        textNo.style.opacity = 0;
        transform = {
          translate: {
            x: 0,
            y: offsetTop
          },
          angle: 0
        };
        requestElementUpdate();
      }
      resetElement();

      function updateElementTransform() {
        let value = [
          'translate3d(' + transform.translate.x + 'px, ' + transform.translate.y + 'px, 0)',
          'rotate(' + transform.angle + 'deg)'
        ].join(" ");

        element.style.webkitTransform = value;
        element.style.mozTransform = value;
        element.style.transform = value;
        active = false;
      }

      function offScreenRight(ev) {
        element.className = 'card tinder-card animate';
        transform.translate = {
          x: (ev.deltaX * 3),
          y: (ev.deltaY * 3)
        };
        requestElementUpdate();
        window.setTimeout(function(){
          element.parentNode.removeChild(element);
          panel.emitEvent('on.swipe.liked', {index:attrs.index});
        }, 500);
      }

      function offScreenLeft(ev) {
        element.className = 'card tinder-card animate';
        transform.translate = {
          x: (ev.deltaX * 3),
          y: (ev.deltaY * 3)
        };
        requestElementUpdate();
        window.setTimeout(function(){
          element.parentNode.removeChild(element);
          panel.emitEvent('on.swipe.disliked', {index:attrs.index});
        }, 500);
      }

      mc.on("hammer.input", (ev) =>  {
        if (ev.isFinal) {
          if (parseInt(textYes.style.opacity) === 1) {
            offScreenRight(ev);
          } else if (parseInt(textNo.style.opacity) === 1) {
            offScreenLeft(ev);
          } else {
            resetElement();
          }
        }
      });

      mc.on("panstart panmove", (ev) => {
        let MAX_ANGLE = 25;
        element.className = 'card tinder-card';
        transform.translate = {
          x: ev.deltaX,
          y: ev.deltaY
        };

        // change opacity of the LIKE / NOPE text and angle of card
        let multiplier = Math.min(Math.max(Math.abs(ev.deltaX) / (element.offsetWidth / 1.5), 0), 1);
        if(ev.deltaX > 0) {
          transform.angle = MAX_ANGLE * multiplier;
          textYes.style.opacity = multiplier;
          textNo.style.opacity = 0;
        } else if (ev.deltaX <= 0) {
          transform.angle = -MAX_ANGLE * multiplier;
          textYes.style.opacity = 0;
          textNo.style.opacity = multiplier;
        }

        requestElementUpdate();
      });
    }
  };
}

export default angular.module('directives.swipeCard', [panel]).directive('swipeCard', swipeCard).name;



// WEBPACK FOOTER //
// ./src/app/directives/swipeCard.js